import React from 'react';
import styled from 'styled-components';
import { colors } from '../styles/colors';
import { AppStoreButtons } from '../components/AppStoreButtons';

const HeroContainer = styled.section`
  min-height: 100vh;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.primaryLight} 100%);
  color: white;
  position: relative;
  overflow: hidden;
  
  @media (max-width: 768px) {
    padding: 60px 0;
  }
  
  @media (max-width: 480px) {
    padding: 40px 0;
  }
`;

const HeroContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 80px;
  align-items: center;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 80px;
    text-align: center;
    padding: 0 20px;
  }
  
  @media (max-width: 480px) {
    gap: 60px;
    padding: 0 16px;
  }
`;

const TextContent = styled.div`
  z-index: 2;
`;

const Title = styled.h1`
  font-size: 56px;
  font-weight: 700;
  line-height: 1.1;
  margin-bottom: 24px;
  color: white;
  
  @media (max-width: 768px) {
    font-size: 40px;
  }
  
  @media (max-width: 480px) {
    font-size: 32px;
  }
`;

const Subtitle = styled.p`
  font-size: 20px;
  line-height: 1.5;
  margin-bottom: 32px;
  opacity: 0.9;
  
  @media (max-width: 768px) {
    font-size: 18px;
  }
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: flex-start;
  
  @media (max-width: 768px) {
    align-items: center;
  }
`;

const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 24px 0;
  
  @media (max-width: 768px) {
    display: none;
  }
  
  li {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
    font-size: 16px;
    
    &::before {
      content: '✨';
      color: ${colors.success};
      font-weight: bold;
      font-size: 18px;
    }
  }
`;

const ImageContent = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  
  @media (max-width: 768px) {
    order: -1;
  }
`;

const PhoneImage = styled.img`
  width: 400px;
  height: 750px;
  object-fit: cover;
  object-position: center;
  border-radius: 30px;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  background: transparent;
  filter: brightness(1.1) contrast(1.1);
  clip-path: inset(10px 20px 40px 30px);
  
  @media (max-width: 768px) {
    width: 250px;
    height: 500px;
    clip-path: inset(10px 2px 25px 6px);
  }
`;

export const HeroSection: React.FC = () => {
  return (
    <HeroContainer data-section="hero">
      <HeroContent>
        <TextContent>
          <Title>
            당신의 투자 멘토를
            <br />
            선택하세요
          </Title>
          <Subtitle>
            9명의 투자 전설이 당신만의 AI 멘토가 됩니다.
            <br />
            워렌 버핏부터 캐시 우드까지, 전설적 투자자들의 철학으로
            당신의 투자 고민을 분석하고 해답을 찾아보세요.
          </Subtitle>

          <FeatureList>
            <li>워렌 버핏처럼 생각하고, AI처럼 분석</li>
            <li>9가지 전문 분석으로 나만의 투자 철학 만들기</li>
            <li>개인화된 포트폴리오 관리</li>
            <li>교육 중심의 투자 습관 형성</li>
          </FeatureList>

          <ButtonGroup>
            <AppStoreButtons
              googlePlayUrl="https://play.google.com/store/apps/details?id=com.tobeAi.tobe"
              appStoreUrl="https://apps.apple.com/us/app/%ED%88%AC%EB%B9%84/id6749519861"
            />
          </ButtonGroup>
        </TextContent>

        <ImageContent>
          <PhoneImage src="/images/MockUp.png" alt="tobe AI 앱 미리보기" />
        </ImageContent>
      </HeroContent>
    </HeroContainer>
  );
}; 